export default function CtaBand() {
  return (
    <section className="relative overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20warm%20amber%20and%20teal%20geometric%20gradient%20background%20with%20flowing%20waves%20and%20soft%20paper%20texture%2C%20minimal%20modern%20editorial%20poster%20style%2C%20smooth%20curves%2C%20high%20detail%2C%20harmonious%20balanced%20composition%2C%20no%20text&width=1600&height=600&seq=cta-band-91&orientation=landscape"
          alt="91免费版下载安装指引"
          title="91免费版app下载"
          className="h-full w-full object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-foreground-950/85 via-foreground-950/70 to-foreground-950/45" />
      </div>

      <div className="relative mx-auto flex max-w-none flex-col items-start gap-6 px-4 py-12 md:flex-row md:items-center md:justify-between md:px-6 md:py-16">
        <div className="max-w-xl">
          <h2 className="font-heading text-2xl font-bold text-background-50 md:text-3xl">
            选好平台，一步拿到安装包
          </h2>
          <p className="mt-3 text-sm leading-relaxed text-background-200">
            安卓、iOS 与电脑端均可，安装过程遇到问题还能回到本页对照排查，全程不用来回找教程。
          </p>
        </div>
        <div className="flex flex-col gap-3 sm:flex-row">
          <a
            href="#download"
            className="flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-5 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
          >
            <i className="ri-download-2-line" />
            前往下载入口
          </a>
          <a
            href="#faq"
            className="flex items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-50/40 px-5 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-background-50/10"
          >
            <i className="ri-question-line" />
            查看常见问题
          </a>
        </div>
      </div>
    </section>
  );
}